import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllUsersService = (page = 1, limit = 100, flagged = false) => {
  return HTTP_CLIENT.get(
    `${Endpoint.users.getUsers}?&page=${page}&limit=${limit}${
      flagged ? `&flagged=${flagged}` : ""
    }`
  );
};

const SuspendUserService = (id: number) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.users.suspend.replace(":id", id.toString())}`
  );
};

const UnSuspendUserService = (id: number) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.users.unsuspend.replace(":id", id.toString())}`
  );
};

const FlagUserService = (id: number, data: any) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.users.flag.replace(":id", id.toString())}`,
    data
  );
};

const UnFlagUserService = (id: number) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.users.unflag.replace(":id", id.toString())}`
  );
};

export {
  GetAllUsersService,
  SuspendUserService,
  UnSuspendUserService,
  FlagUserService,
  UnFlagUserService,
};
